/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.BuyingRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const createPurchaseOrderRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'createPurchaseOrder',
  auth: 'app',
  fingerprint: 'IP-5TvLibZnY5pstqgNqILbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsProductInventoryRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getSeatsProductInventory',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACHTP33O5UJ5JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};